/**
 * TIC — "Find a Local Retailer" header button injector
 * Runs on every page, injects a fixed-position gold CTA in the top-left.
 * Hides itself on the retailer page to avoid redundancy.
 */
(function () {
  function inject() {
    // Hide on the retailer page itself
    if (/\/pages\/find-a-retailer\/?$/.test(window.location.pathname)) return;
    // No double-injection
    if (document.querySelector('.tic-find-retailer-btn')) return;

    var a = document.createElement('a');
    a.href = '/pages/find-a-retailer';
    a.className = 'tic-find-retailer-btn';
    a.textContent = 'Find a Local Retailer';
    a.setAttribute('aria-label', 'Find a local retailer');
    document.body.appendChild(a);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  // Atelier uses view transitions — re-inject after navigation if lost
  window.addEventListener('pageshow', inject);
})();
